import type { OnRequestConfigDto } from "@tripcart/shared";

export type QuoteAction =
  | { kind: "navigate"; url: string; newTab: boolean }
  | { kind: "email"; address: string }
  | { kind: "tel"; number: string }
  | { kind: "whatsapp"; number: string }
  | { kind: "form" }
  | { kind: "unavailable" };

/** Resolves the Button link action (doc §5/§6.2) for an on-request quote
 *  CTA, wherever it appears on the page. Mirrors `_booking-sidebar.tsx`'s own
 *  quote-button branch order exactly — a custom link wins, then the legacy
 *  email/phone/whatsapp actions, then the chosen inquiry form. `unavailable`
 *  is the same "no form configured" state the sidebar renders as a disabled
 *  button, for a tour that picked "Open inquiry form" but whose chosen form
 *  was since deleted (AC-14). */
export function resolveQuoteAction(
  onRequest: OnRequestConfigDto | undefined,
): QuoteAction {
  if (!onRequest) {
    return { kind: "unavailable" };
  }
  if (onRequest.linkMode === "url" && onRequest.linkUrl) {
    return {
      kind: "navigate",
      url: onRequest.linkUrl,
      newTab: onRequest.linkOpensNewTab,
    };
  }
  if (onRequest.buttonAction === "email") {
    return { kind: "email", address: onRequest.contactEmail };
  }
  if (onRequest.buttonAction === "phone") {
    return { kind: "tel", number: onRequest.contactPhone };
  }
  if (onRequest.buttonAction === "whatsapp") {
    return { kind: "whatsapp", number: onRequest.whatsapp };
  }
  if (onRequest.requestedForm) {
    return { kind: "form" };
  }
  return { kind: "unavailable" };
}
